import { Box, styled } from '@mui/material';

export const StyledCalendarWrapper = styled(Box)(
  ({ theme }) => `

  padding-top: 16px;
  height: 100%;
  font-family: 'Roboto';
  font-size: 14px;
  color: ${theme.palette.brand.charcoal};

  & .fc-event.fc-event-draggable {
    cursor: default;
  }


  & .fc-theme-standard {
      td { 
        border: 2px solid ${theme.palette.brand.ash}; 
      }

      th { 
        border: 2px solid ${theme.palette.brand.ash}; 
        border-bottom: 0; 
      }

      & .fc-scrollgrid { 
        border: 2px solid ${theme.palette.brand.ash}; 
        border-radius: 4px; 
      }
  }


  
  & .fc {

    & tfoot {
      display: none;
    }


    & tbody {
      & tr {
        &.fc-timeline-header-row {
          height: auto;
        }
      }
    }

    & td {
      & .fc-datagrid-cell-frame {
        height: 100%;
        display: flex;
        align-items: center;
      }
    }

    & .fc-timeline-body {
      background:${theme.palette.brand.lightGrey};
    }

    & .fc-resource-timeline-divider {
      border: none;
      width: 1px;
    }

    & .fc-event {
      background-color: transparent;
      width: 100%;
      border: none;
      border-radius: 4px;
      color: ${theme.palette.brand.black};
      margin: 8px 0 0 0;
      padding-bottom: 0;
      padding-left: 3px;
      padding-right: 3px;

      &:focus {
        box-shadow: none;
      }



      &:before,
      &:after {
        display: none ;
      }
    }

    & .fc-timeline-more-link {
      background: none;
      font-weight: 500;
      font-size: 14px;
      line-height: 1.7;
      color: ${theme.palette.primary.main};
      margin-left: 8px;
      margin-top: 10px;
    }

    & .fc-event-main {
      color: ${theme.palette.brand.black};
      font-size: 12px;
      line-height: 1.33;
      font-family: 'Roboto';
      font-weight: 400;
    }

    & .fc-popover {
      width: 400px;
      padding: 20px;
      border-radius: 4px;
      z-index: 1050 !important;

      & .fc-popover-header {
        background: none;
        font-size: 20px;
        line-height: 1.6;
        font-weight: 500;
        color: ${theme.palette.brand.black};
      }
    }

    & .fc-timeline-slot-frame {
      height: 48px !important;
      font-weight: 500;
       position: relative;
      
    }

    & .fc-timeline-header-row-chrono {
      & .fc-timeline-slot-frame {
        justify-content: center;
      }
    }

    & .fc-datagrid-header {
      & .fc-datagrid-cell-frame{
        justify-content: center;
      }  
    }

    & .fc-datagrid-cell.fc-resource,
    & .fc-scrollgrid-section.fc-scrollgrid-section-header {
    }

    /* Hide FullCalendar sync/shim scrollbars in header/footer sections. */
    & .fc-scrollgrid-section-header .fc-scroller
     {
      scrollbar-width: none;
    }

    /* Hide only the resource-column body scrollbar, not the main timeline scrollbar. */
    & .fc-scrollgrid-section-body > td:first-of-type .fc-scroller {
      scrollbar-width: none;
    }

    & .fc-toolbar-title {
      font-size: 22px;
      line-height: 1.18;
      font-weight: 400;
    }

    & .fc-button-primary:not(:disabled).fc-button-active:focus,
    & .fc-button-primary:not(:disabled):active:focus {
      box-shadow: none;
    }

    .fc-resourceTimelineMonth-view .preview-text,
    .fc-resourceTimelineYear-view .preview-text {
      display: none !important;
    }
    & .fc-button-primary {
      background: none;
      color: ${theme.palette.primary.main};
      border-color: ${theme.palette.primary.main};
      opacity: unset;
      min-width: 87px;
      text-transform: capitalize;

      &:focus {
        box-shadow: none;
      }

      &:active {
        background: ${theme.palette.primary.main};
        color: ${theme.palette.primary.lightest};
      }

      &.fc-button-active {
        background: ${theme.palette.primary.main};
      }

      &.fc-prev-button,
      &.fc-next-button {
        border: none;
        min-width: unset;
        width: 40px;
        color: ${theme.palette.brand.charcoal};

        &:active {
          background: none;
        }
      }
    }
  }
  `,
);
export const WeekdayHeader = styled('div')({
  width: '100%',
  height: '100%',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const WeekdayText = styled('span')<{ hasPreview?: boolean }>(
  ({ hasPreview }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    fontWeight: 500,
    transition: 'opacity 0.2s',
    ...(hasPreview && {
      [`${WeekdayHeader}:hover &`]: {
        opacity: 0,
      },
    }),
  }),
);

export const PreviewButton = styled('button')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'none',
  border: 'none',
  color: theme.palette.primary.main,
  opacity: 0,
  pointerEvents: 'none',
  transition: 'opacity 0.2s',
  cursor: 'pointer',
  '& svg': {
    marginRight: 6,
  },
  [`${WeekdayHeader}:hover &`]: {
    opacity: 1,
    pointerEvents: 'auto',
  },
  '&:disabled': {
    color: theme.palette.brand.darkGrey,
    cursor: 'not-allowed',
  },
  [`${WeekdayHeader}:hover &:disabled`]: {
    opacity: 1,
    pointerEvents: 'none',
  },
}));
